<template>
<div  >

  <nav class="navbar is-primary" role="navigation" aria-label="main navigation" style="background-color: #205081;">
    <div class="navbar-brand">

      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-start">
        <a class="navbar-item">
            <!-- <label style="font-size:30px;" > {{ $cookies.get('RhSession').name }} {{$cookies.get('RhSession')}} </label> -->
            <label style="font-size:30px;" > Welcome {{ $cookies.get('RhSession').name }} </label>
        </a>
        <!-- <div class="field has-addons" style="margin-top:13px;">
          <div class="control">
            <input class="input" type="text" v-model="buscaReserva" placeholder="Buscar reservación">
          </div>
          <div class="control">
            <input class="input" type="date" v-model="buscaReservaFecha" >
          </div>
          <div class="control">
            <a class="button is-info" @click="buscarReservacion">
              Buscar
            </a>
          </div>
        </div> -->
      </div>
      <div class="navbar-end">
        <div class="navbar-item">

          <div class="dropdown is-right">
            <div class="dropdown-trigger">
              <button class="button badge" aria-haspopup="true" data-badge="8" aria-controls="dropdown-menu3">

                <font-awesome-icon icon="bell" />

              </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu3" role="menu" style="width:500px; border-radius:10px;" >

              <div style="background:#2a6db2; border-radius:10px 10px 0 0; font-size: 18px;text-align:center;">
                <label style="color:white;"> Notificaciones </label>
              </div>

              <div style="background:#205081; height:300px; overflow-Y: scroll;">
                <table class=" table is-striped is-narrow is-hoverable is-fullwidth " style="background:#205081;">

                    <tr v-for="n in 10">
                      <td> <img src="https://bulma.io/images/placeholders/128x128.png"> </td>
                      <td style="color:white;">
                        <label style="font-size:13px; color:#ffb95e;" > Sarahi Ventura - hace {{ n }} minuto </label> <br>
                        <label >  Hay nuevas requisiciones </label>
                      </td>
                      <td> <font-awesome-icon icon="times" class="fa-2x" style="color:red; cursor: pointer;" /> </td>
                    </tr>

                </table>
              </div>

              <div style="background:#2a6db2; border-radius: 0 0 10px 10px; text-align: center;">
                <a style="color:white;" @click="changeCompon('app-notificaciones') "> Ver todas las notificaciones </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

  </nav>

  <!-- {{total}} -->
  <div class="columns">
    <div class="column is-2 " style="background-color: #f4f4f4;" >
      <br><br>

      <aside class="menu" >
        <p class="menu-label">
          &nbsp;&nbsp;&nbsp; Support
        </p>
        <ul class="menu-list">
          <li>
            <ul>
               <!-- <li><router-link tag="a" to="/cloud"> <font-awesome-icon icon="users" /> Cloud </router-link></li> -->
               <li><router-link tag="a" to="/assistant"> <font-awesome-icon icon="users" /> Assistant </router-link></li>
            </ul>
          </li>
        </ul>
      </aside>

      <!-- <aside class="menu" v-if="$can('create', $session.getAll().sessionRH.name )" > -->
        <aside v-if="$cookies.get('RhSession').rol==1" class="menu" >
        <p class="menu-label">
          &nbsp;&nbsp;&nbsp; Settings
        </p>
        <ul class="menu-list">
          <li>
            <ul>
              
              <!-- <li><router-link tag="a" to="/reservar"> <font-awesome-icon icon="users" /> Reservar</router-link></li> -->
              <li><router-link tag="a" :to="'/new/'"> <font-awesome-icon icon="users" /> New </router-link></li>
              <!-- <li><router-link tag="a" :to="'/service/1'"> <font-awesome-icon icon="users" /> Service</router-link></li>
              <li><router-link tag="a" to="/pickups-asignacion"> <font-awesome-icon icon="calendar-alt" /> Pickups Asignación</router-link></li>
              <li> <a :class="(validadorClick == 17) ? 'is-active' : '' " @click="changeCompon('app-pickups_reporte'),validadorClick = 17 "><font-awesome-icon icon="calendar-alt" /> Pickups Reporte </a> </li>
              <li> <a :class="(validadorClick == 18) ? 'is-active' : '' " @click="changeCompon('app-regresos'),validadorClick = 18 "><font-awesome-icon icon="calendar-alt" /> Regresos </a> </li>
              <li> <a :class="(validadorClick == 19) ? 'is-active' : '' " @click="changeCompon('app-regresos_reporte'),validadorClick = 19 "><font-awesome-icon icon="calendar-alt" /> Regresos Reporte </a> </li>
              <li> <a :class="(validadorClick == 21) ? 'is-active' : '' " @click="changeCompon('app-no_show'),validadorClick = 21 "><font-awesome-icon icon="calendar-alt" /> No Show </a> </li>
              <li> <a :class="(validadorClick == 22) ? 'is-active' : '' " @click="changeCompon('app-cancelados'),validadorClick = 22 "><font-awesome-icon icon="calendar-alt" /> Cancelados </a> </li>
              <li> <a :class="(validadorClick == 20) ? 'is-active' : '' " @click="changeCompon('app-gps'),validadorClick = 20 "><font-awesome-icon icon="calendar-alt" /> GPS </a> </li> -->
            </ul>
          </li>
        </ul>
      </aside>

      


      <aside class="menu">
        <p class="menu-label">
          &nbsp;&nbsp;&nbsp; Session
        </p>
        <ul class="menu-list">
          <li>
            <ul>
              <li>
                <a  @click="cerrarSesion"> <font-awesome-icon icon="sign-out-alt" />  Sign out</a>
              </li>
              <!-- <li>
                <a @click="changeCompon('app-historial'),validadorClick = 11 "> 
                <font-awesome-icon icon="exchange-alt" />   Historial Movimientos </a>
              </li> -->

            </ul>
          </li>
        </ul>
      </aside>

    </div>
    <div class="column is-10" style="overflow-y: scroll; overflow-x: scroll; height: 90vh; margin:0px; display:flex; flex-direction: column;" >
      <router-view></router-view>
      <!-- <component :is="menuComponente" ></component> -->
    </div>

  </div>

  <div id="modalBusqueda" class="modal" align="center">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <span class="modal-card-title">
          <strong>Búsqueda en fecha {{this.buscaReservaFecha}}</strong>
        </span>
        <button class="delete" @click="cerrarModalBusqueda" aria-label="close"></button>
      </header>
      <section class="modal-card-body" align="left">
        
        <template v-for="reserva in reservacionesList" >
          <span v-text="reserva.cliente"> </span><br>
        </template>


      </section>
      <footer class="modal-card-foot">
        <button @click="cerrarModalBusqueda" class="button is-info">Cerrar</button>
      </footer>
    </div>
  </div>

</div>
</template>

<script>

import axios from 'axios'
import Cors from 'cors'
import moment from 'moment'

import { EventBus } from './bus.js';
import qs from 'qs'

import Reservar from './empleados/reservar.vue'
import Pickups from './empleados/pickups.vue'
import PickupsReporte from './empleados/pickups_reporte.vue'
import Regresos from './empleados/regresos.vue'
import RegresosReporte from './empleados/regresos_reporte.vue'
import NoShow from './empleados/no_show.vue'
import Cancelados from './empleados/cancelados.vue'
import Gps from './empleados/gps.vue'

import Cloud from './sistemy/cloud.vue'

export default {

  components: {
    'app-reservar': Reservar,
    'app-pickups' : Pickups,
    'app-pickups_reporte' : PickupsReporte,
    'app-regresos' : Regresos,
    'app-regresos_reporte' : RegresosReporte,
    'app-no_show' : NoShow,
    'app-cancelados' : Cancelados,
    'app-gps' : Gps,

    'app-cloud' : Cloud
  },
  data () {
    return {
      menuComponente: 'app-reservar',
      mail: '',
      pass: '',
      option: '0',
      alturaVentana: window.innerHeight - 100,
      anchoVentana: window.innerWidth - 20,
      validadorClick: 0,
      total: 0,
      buscaReservaFecha: moment().format('DD-MM-YYYY'),
      buscaReserva:'',
      reservacionesList:'',
      host: 'booking.vws.com.mx'

    }
  },
  computed: {

  },

  created () {
    var estancia = this;
    console.log("test jp",this.$route.path)
    console.log(this.$route.params,'params')


    EventBus.$on('cambioCompon',(datoInt, datoString) => {

      estancia.changeCompon(datoString);
      estancia.validadorClick = datoInt ;

    })

    document.addEventListener('DOMContentLoaded', function () {
      // Dropdowns
      var $dropdowns = getAll('.dropdown:not(.is-hoverable)')

      if ($dropdowns.length > 0) {
        $dropdowns.forEach(function ($el) {
          $el.addEventListener('click', function (event) {
            event.stopPropagation()
            $el.classList.toggle('is-active')
          })
        })

        document.addEventListener('click', function (event) {
          closeDropdowns()
        })
      }

      function closeDropdowns () {
        $dropdowns.forEach(function ($el) {
          $el.classList.remove('is-active')
        })
      }

      // Close dropdowns if ESC pressed
      document.addEventListener('keydown', function (event) {
        var e = event || window.event
        if (e.keyCode === 27) {
          closeDropdowns()
        }
      })

      // Functions

      function getAll (selector) {
        return Array.prototype.slice.call(document.querySelectorAll(selector), 0)
      }

    })
  },
  methods: {
    buscarReservacion () {
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'monedas',
        //   where: '',
        //   condition: ''
        // })
        var select = `*`;
        var tabla = "reservaciones";
        var where = " fecha = '"+this.buscaReservaFecha+"' and cliente like '%"+this.buscaReserva+"%' ";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response)=>{
          if (response.status == 200 ) {
            this.reservacionesList = response.data;
            console.log(response,'response');
            $("#modalBusqueda").addClass("is-active");
          }else{
            console.log('error');
          }
        });
    },
    cerrarModalBusqueda:function(){
      $("#modalBusqueda").removeClass("is-active");
      this.reservacionesList=''
      this.buscaReserva=''
    },
    hoy () {
      return moment().format('DD-MM-YYYY')
    },
    cerrarSesion: function () {
      this.$cookies.remove('RhSession')
      location.reload()
    },
    current: function (selected) {
      this.option = selected
    },
    changeCompon: function (data) {
      console.log('cambiamos el componente')
      console.log(data)
      this.menuComponente = data
    }
  }
}
</script>